import { Password } from 'primereact/password'
import { Field } from 'formik'
import React from 'react'

const PasswordEditor = ({
  fieldName,
  fieldLabel,
  placeholder,
  value,
  error,
  handleChange,
  handleBlur,
  disabled = false,
  passwordMeter = false
} :
							{
								fieldName: any,
								fieldLabel?: any,
								placeholder?:any,
								value: any,
								error: any,
								handleChange: any,
								handleBlur: any,
								disabled?: boolean
								passwordMeter?:boolean
							}) => {
  return <div className=''>
    <div className='form-group w-100'>
      {fieldLabel ? <label htmlFor={'input' + fieldName}>{fieldLabel}</label> : ''}
      <Password
        // @ts-ignore
        className={`form-control ${error ? 'is-invalid' : ''}`}
        id={'input' + fieldName}
        name={fieldName}
        placeholder={placeholder || fieldLabel}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={disabled}
        feedback={passwordMeter}
		weakLabel='Gyenge'
		mediumLabel='Közepes'
		strongLabel='Erős'
		promptLabel='Írd be a jelszót!'
      />
      <div className='error-message'>
        <Field
          name={fieldName}
          className='error-message'
          render={({ form }: { form: any }) => {
            return error || null
          }}
        />
      </div>
    </div>
  </div>
}

export default PasswordEditor
